export default "### Privacy Statement\n[Here you can insert the privacy statements for this software...]"